// SearchBar.tsx
import React from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import { Clear as ClearIcon } from '@mui/icons-material';

interface SearchBarProps {
    searchText: string;
    onSearchTextChange: (text: string) => void;
    onClearSearch: () => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ searchText, onSearchTextChange, onClearSearch }) => (
    <TextField
        label="Поиск по участникам"
        variant="outlined"
        value={searchText}
        onChange={(e) => onSearchTextChange(e.target.value)}
        InputProps={{
            endAdornment: (
                <InputAdornment position="end">
                    {searchText && (
                        <IconButton onClick={onClearSearch}>
                            <ClearIcon />
                        </IconButton>
                    )}
                </InputAdornment>
            ),
        }}
        fullWidth
    />
);

export default SearchBar;